import { render, staticRenderFns } from "./paginationDefault.vue?vue&type=template&id=ce8452e8"
import script from "./paginationDefault.vue?vue&type=script&lang=js"
export * from "./paginationDefault.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports